import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { desktop, mobile } from '../../../styles/media'
import MasterDuelUltraRare from '../../../images/master-duel/master-duel-cp-ur.png'
import { calculateMasterDuelCp } from '../../../helper/deck'
import MasterDuelSuperRare from '../../../images/master-duel/master-duel-cp-sr.png'

const MasterDuelCosts = ({ deck }) => (
	<StyledMasterDuelCosts>
		<MasterDuelCost>
			<img src={MasterDuelUltraRare} alt="" />
			{calculateMasterDuelCp(deck, 'UR')}
		</MasterDuelCost>
		<MasterDuelCost>
			<img src={MasterDuelSuperRare} alt="" />
			{calculateMasterDuelCp(deck, 'SR')}
		</MasterDuelCost>
	</StyledMasterDuelCosts>
)

MasterDuelCosts.propTypes = {
	deck: PropTypes.object.isRequired
}

export const StyledMasterDuelCosts = styled.div`
	display: flex;
`

const MasterDuelCost = styled.div`
	align-items: center;
	display: flex;

	color: #FFF;
	font-size: 0.8rem;
	font-weight: 600;

	& + & {
		margin-left: 0.5rem;
	}

	img {
		height: 24px;
		width: 24px;
	}

	${desktop`
		flex-direction: column;
		font-size: 0.7rem;

		img {
			margin-bottom: 0.15rem;
		}

		& + & {
			margin-left: 0.75rem;
		}
	`}

	${mobile`
		img {
			margin-right: 0.35rem;
		}
	`}
`

export default MasterDuelCosts
